import getSmimeAttachmentType from './getSmimeAttachmentType';
import mergeSmimeDecodedMessageProperties from '../actions/mergeSmimeDecodedMessageProperties';
import prepareMessageForSmimeDraft from '../actions/prepareMessageForSmimeDraft';
import fetchAndDecodeSmimeMessage from '../services/fetchAndDecodeSmimeMessage';
import { getDefaultRoutingKey } from 'owa-client-ids';
import Message from 'owa-service/lib/contract/Message';
import { lazySmimeAdapter } from 'owa-smime-adapter';
import SmimeMessage from 'owa-smime-adapter/lib/store/schema/SmimeMessage';
import SmimeType from 'owa-smime-adapter/lib/store/schema/SmimeType';
import isSmimeAdapterUsable from 'owa-smime-adapter/lib/utils/isSmimeAdapterUsable';

/**
 * This function decodes the encrypted/signed draft message
 * and updates it with decoded properties.
 * @param draftMessage S/MIME message to be decoded
 */
const setSmimePropertiesInDraftMessage = async (draftMessage: Message): Promise<SmimeType> => {
    const adapter = await lazySmimeAdapter.import();

    if (isSmimeAdapterUsable()) {
        const smimeMessage: SmimeMessage = await fetchAndDecodeSmimeMessage(
            getSmimeAttachmentType(draftMessage),
            getDefaultRoutingKey(),
            adapter
        );

        prepareMessageForSmimeDraft(draftMessage, smimeMessage);
        mergeSmimeDecodedMessageProperties(draftMessage, smimeMessage);

        return smimeMessage.SmimeType;
    } else {
        throw new Error(
            'setSmimePropertiesInDraftMessage: S/MIME adapter is not usable when trying to set S/MIME properties to draft message'
        );
    }
};

export default setSmimePropertiesInDraftMessage;
